import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div className="h-screen flex items-center justify-center bg-bg-primary">
          <div className="bg-bg-secondary border border-border-strong rounded-xl p-8 max-w-md text-center shadow-xl">
            <div className="text-4xl mb-4">⚠️</div>
            <h2 className="text-lg font-bold text-text-primary mb-2">
              Error inesperado
            </h2>
            <p className="text-sm text-text-muted mb-4">
              {this.state.error?.message || 'Algo salió mal'}
            </p>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.reload();
              }}
              className="px-4 py-2 bg-accent-blue text-white rounded-lg text-sm font-semibold hover:opacity-90 transition-opacity"
            >
              Recargar aplicación
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
